$(document).ready(function($) {
  // spectrum
  $('.spectrum-color a').on("click", function(e) {
    e.preventDefault();
    var $target = $(this).closest('.spectrum-color');
    var index = $target.data('index');
    $target.siblings().removeClass('active');
    $target.addClass('active');
    var $activeImagePanels = $target.parents('.spectrum-of-elegance').find('.spectrum-image-container[data-index="'+index+'"]');
    $activeImagePanels.each(function() {
      var $current = $(this);
      $current.siblings().css('z-index', 1);
      $current.css('z-index', 2);
      $current.addClass('active');
      setTimeout(function() {
        $current.siblings().removeClass('active');
      }, 500);
    });
  });
  $('#spectrum-of-elegance .spectrum-color:first-child a').trigger('click');

  // project images carousel
  var $projectImagesCarousel = $('.project-images-small-carousel');
  if ($projectImagesCarousel.is(':visible')) {
    $projectImagesCarousel.flickity({
      cellSelector: '.carousel-cell',
      cellAlign: 'left',
      wrapAround: true,
      draggable: true,
      pageDots: false,
      prevNextButtons: false,
    });
  }
  var $featuredProjectsCarousel = $('#featured-projects .featured-projects-carousel');
  var $featuredProjectInsetsCarousel = $('#featured-projects .featured-project-insets-carousel');
  var hasInsets = $featuredProjectInsetsCarousel.is(':visible');
  var slideDuration = 11500; //in ms
  $featuredProjectsCarousel.css('--projects-transform-duration', slideDuration+'ms');
  $featuredProjectsCarousel.flickity({
    cellSelector: '.carousel-cell',
    cellAlign: 'left',
    wrapAround: true,
    draggable: false,
    pageDots: false,
    autoPlay: slideDuration,
    selectedAttraction: 0.015,
    pauseAutoPlayOnHover: false,
  });
  if (hasInsets) {
    $featuredProjectInsetsCarousel.flickity({
      cellSelector: '.carousel-cell',
      cellAlign: 'left',
      wrapAround: true,
      draggable: false,
      prevNextButtons: false,
      pageDots: false,
      fade: 600,
    });
    $featuredProjectsCarousel.on('select.flickity', function(event, index) {
      $featuredProjectInsetsCarousel.flickity('select', index, true, false);
    });
  }
  $featuredProjectsCarousel.on('select.flickity', function() {
    $(this).find('.carousel-cell').removeClass('is-active');
  });
  $featuredProjectsCarousel.find('.project-number, .project-name').each(function() {
    var childHeight = $(this).children().outerHeight();
    $(this).height(childHeight);
  })
  $featuredProjectsCarousel.on('settle.flickity', function(event, index) {
    $(this).find('.carousel-cell').eq(index).addClass('is-active');
  });
  $featuredProjectsCarousel.find('.carousel-cell').eq(0).addClass('is-active');
})
